import {baseAxios} from '../helper/axiosHelper';

export const languageService = {
    getLanguages,
    getTranslations,
    getSections,
    insertSection,
    insertTranslation,
    updateTranslations,
    exportTranslations,
    getTempTranslations,
    AcceptTempTranslations,
    DropTempTranslations,
    deleteTranslation
};

function getLanguages() {

    return baseAxios.get('language/languages/')
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function getTranslations(data) {

    return baseAxios.get('language/translations/',{params:{language_fk: data.language_fk, section_fk:data.section_fk}} )
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function deleteTranslation(data) {

    return baseAxios.delete('language/translation/',{params:{id:data}} )
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function getSections() {

    return baseAxios.get('language/sections/' )
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function getTempTranslations() {

    return baseAxios.get('language/translations/temp/' )
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function AcceptTempTranslations(data) {

    return baseAxios.post('language/translations/temp/import/',data)
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function DropTempTranslations() {

    return baseAxios.get('language/translations/temp/drop/' )
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function insertSection(section) {

    return baseAxios.post('language/section/',{section:section} )
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function insertTranslation(trans) {

    return baseAxios.post('language/translation/',trans )
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function updateTranslations(trans) {

    return baseAxios.post('language/translations/',trans )
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function exportTranslations(data) {

    return baseAxios.get('language/translations/export/all/',{params:{"type":data.type} })
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}